import * as React from 'react';
import {
  Container, Link, Card, Box, Typography, Collapse, CardActionArea
} from '@mui/material'

import PageWrapper from 'components/PageWrapper';
import PageWrapperBox from 'components/PageWrapperBox';

import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useTranslation, Trans } from "react-i18next";

export default function FaqPage() {

    const { t } = useTranslation();

    const mailLink = <Link href={"mailto:" + t("common.email")} underline="none" />;
    const richText = { b: <b/>, br: <br/>, link: mailLink, about: <Link href="about" /> };

    return <PageWrapper>
            <PageWrapperBox>
            <Typography variant="h6" fontWeight="bold" color="primary" component="div">
                {t("faq.title")}
            </Typography>


            <Typography variant="body" fontWeight="light" component="div" >
                {t("faq.subtitle")}
            </Typography>
            </PageWrapperBox>

            <FAQ title={t("faq.q1.title")} sx={{mt: 2}}>
                <Typography sx={{color: "text.primary", mb: 3}}>
                    <Trans i18nKey="faq.q1.body" components={richText}/>
                </Typography>
            </FAQ>

            <FAQ title={t("faq.q2.title")}>
                <Typography sx={{color: "text.primary", mb: 3}}>
                    <Trans i18nKey="faq.q2.intro" components={richText}/>
                    <ul>
                        <li>{t("faq.q2.item1")}</li>
                        <li>{t("faq.q2.item2")}</li>
                        <li>{t("faq.q2.item3")}</li>
                        <li>{t("faq.q2.item4")}</li>
                        <li>{t("faq.q2.item5")}</li>
                    </ul>
                    {t("faq.q2.outro")}
                </Typography>
            </FAQ>

            <FAQ title={t("faq.q3.title")}>
                <Typography sx={{color: "text.primary", mb: 3}}>
                    <Trans i18nKey="faq.q3.body" components={richText}/>
                </Typography>
            </FAQ>

            <FAQ title={t("faq.q4.title")}>
                <Typography sx={{color: "text.primary", mb: 3}}>
                    <Trans i18nKey="faq.q4.body" components={richText}/>
                </Typography>
            </FAQ>

            <FAQ title={t("faq.q5.title")}>
                <Typography sx={{color: "text.primary", mb: 3}}>
                    <Trans i18nKey="faq.q5.body" components={richText}/>
                </Typography>
            </FAQ>

            <FAQ title={t("faq.q6.title")}>
                <Typography sx={{color: "text.primary", mb: 3}}>
                    <Trans i18nKey="faq.q6.intro" components={richText}/>
                    <ul>
                        <li>{t("faq.q6.item1")}</li>
                        <li>{t("faq.q6.item2")}</li>
                        <li>{t("faq.q6.item3")}</li>
                    </ul>
                    {t("faq.q6.outro")}
                </Typography>
            </FAQ>

            <FAQ title={t("faq.q7.title")}>
                <Typography sx={{color: "text.primary", mb: 3}}>
                    <Trans i18nKey="faq.q7.body" components={richText}/>
                </Typography>
            </FAQ>

            <FAQ title={t("faq.q8.title")}>
                <Typography sx={{color: "text.primary", mb: 3}}>
                    <Trans i18nKey="faq.q8.body" components={richText}/>
                </Typography>
            </FAQ>


    </PageWrapper>
}

const FAQ = ({title, children, sx}) => {
    const [open, setOpen] = React.useState(false);



    return <>

    <Box sx={{backgroundColor: "primary.main", borderRadius: 2, mb: 1, ...sx}}>
        <CardActionArea sx={{flexDirection: "row", display: "flex", py: 1, px: 2, justifyContent: "flex-start"}} onClick={()=>{setOpen(!open)}}>
            <ChevronRightIcon style={{ transform: open ? "rotate(90deg)" : "rotate(0)", transition: "all 0.1s linear", color: "white" }}/>

            <Typography sx={{px: 1, color: "white"}} fontWeight="bold">{title}</Typography>
        </CardActionArea>
    </Box>

    <Collapse in={open}>
        {children}
    </Collapse>

</>}
